module.exports = __webpack_public_path__ + "img/bg-image-15.a4483b11.jpg";